module.exports = __webpack_public_path__ + "static/media/cuenta-drn.03431541.png";